import { LOCAL_STORAGE_VARIABLES } from "../../../shared/constants";
import { BaseStorageService } from "../base.service";

export class LocalStorageService extends BaseStorageService {

  public getAll() {
    const local = {};
    Object.values(LOCAL_STORAGE_VARIABLES).forEach(val => {
      local[val] = this.get(val);
    });
    return local;
  }

  public clearByRememberMe() {
    this.remove(LOCAL_STORAGE_VARIABLES.ACCESS_TOKEN);
    this.remove(LOCAL_STORAGE_VARIABLES.USER_ID);
    this.remove(LOCAL_STORAGE_VARIABLES.USER_DATA);
  }

  public getAccessToken() {
    return this.get(LOCAL_STORAGE_VARIABLES.ACCESS_TOKEN);
  }

  public setAccessToken(accessToken) {
    this.set(LOCAL_STORAGE_VARIABLES.ACCESS_TOKEN, accessToken);
  }

  public getUserId() {
    return this.get(LOCAL_STORAGE_VARIABLES.USER_ID);
  }

  public setUserId(userId) {
    this.set(LOCAL_STORAGE_VARIABLES.USER_ID, userId);
  }

  public setRememberMe(isRememberMe) {
    this.set(LOCAL_STORAGE_VARIABLES.REMEMBER_ME, isRememberMe);
  }

  public getRememberMe() {
    return this.get(LOCAL_STORAGE_VARIABLES.REMEMBER_ME);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/storage/custom/local-storage.service.ts